/* eslint-disable */
import type { LocalizableString } from "../../cash/localization/localization.pb";
import type { BlockerAction } from "../blocker_action.pb";

/** Describes a help item text and action. */
export interface HelpItem {
  text?: string;
  localized_text?: LocalizableString;
  /** The action to take when this help option is selected. */
  action?: HelpItemAction;
  /**
   * The URL to navigate to when the item is selected.
   * Must be populated when action is OPEN_URL.
   */
  url?: string;
  /**
   * The action to pass to SelectOption when the item is selected.
   * Must be populated when action is SELECT_OPTION.
   */
  select_option_action?: string;
  /**
   * If non-null, this text should be displayed in a dialog with Ok/Cancel options before
   * performing the action.
   */
  confirm_dialog_text?: string;
  /**
   * The optional starting token to pass to StartSupportFlow, if action is START_SUPPORT_FLOW.
   *
   * @deprecated
   */
  support_node_token?: string;
  /**
   * The client scenario to switch to, if the action is START_CLIENT_SCENARIO.
   *
   * @deprecated
   */
  client_scenario?: string;
  /** Title of the inline message. Must be supplied if action is SHOW_MESSAGE. */
  message_title?: string;
  /** Text of the inline message. Must be supplied if action is SHOW_MESSAGE. */
  message_text?: string;
  /** Action to perform. Must be supplied if action is BLOCKER_ACTION. */
  blocker_action?: BlockerAction;
}

/** Use BLOCKER_ACTION for deprecated actions. */
export enum HelpItemAction {
  /**
   * GET_SCENARIO_PLAN - Call GetScenarioPlan and continue with the returned scenario plan.
   *
   * @deprecated
   */
  GET_SCENARIO_PLAN = "GET_SCENARIO_PLAN",
  /**
   * RESOLVE_MERGE_FALSE - Call the resolve merge api with confirm_merge=false.
   *
   * @deprecated
   */
  RESOLVE_MERGE_FALSE = "RESOLVE_MERGE_FALSE",
  /**
   * SKIP_BLOCKER - Call the SkipBlocker api.
   *
   * @deprecated
   */
  SKIP_BLOCKER = "SKIP_BLOCKER",
  /**
   * OPEN_URL - Open the URL in the url field.
   *
   * @deprecated
   */
  OPEN_URL = "OPEN_URL",
  /** SELECT_OPTION - Call SelectOption with the action in select_option_action field. */
  SELECT_OPTION = "SELECT_OPTION",
  /**
   * SIGN_OUT - Clear the session, flow token, and return to the sign in screen.
   *
   * @deprecated
   */
  SIGN_OUT = "SIGN_OUT",
  /**
   * START_SUPPORT_FLOW - Open the in-app support flow, passing in the support_node_token if supplied.
   *
   * @deprecated
   */
  START_SUPPORT_FLOW = "START_SUPPORT_FLOW",
  /**
   * START_CLIENT_SCENARIO - Switch to a new client scenario and call CompleteScenario to proceed.
   *
   * @deprecated
   */
  START_CLIENT_SCENARIO = "START_CLIENT_SCENARIO",
  /**
   * SHOW_MESSAGE - Show an inline message with message_title and message_text.
   *
   * @deprecated
   */
  SHOW_MESSAGE = "SHOW_MESSAGE",
  /** BLOCKER_ACTION - Performs the action specified in blocker_action. */
  BLOCKER_ACTION = "BLOCKER_ACTION",
}
